import type { EventsLegendProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/EventsLegend/index.types';
import React from 'react';

const LEGEND_ITEMS = [
  { label: 'SIP', dotClassName: 'bg-sky-400' },
  { label: 'RTP', dotClassName: 'bg-emerald-400' },
  { label: 'Device', dotClassName: 'bg-amber-400' },
  { label: 'Call', dotClassName: 'bg-violet-400' },
];

/**
 * EventsLegend - Footer key for the event colours, plus how full the buffer is
 *
 * The buffer counter is here because the 500-event cap is otherwise only
 * discovered by its effects: a multi-leg scenario that lost its own
 * beginning.
 */
export const EventsLegend: React.FC<EventsLegendProps> = ({
  bufferCount,
  bufferMax,
}) => (
  <div className="flex items-center gap-3.5 bg-zinc-900 px-[11px] py-[9px] text-[10.5px] text-zinc-400">
    {LEGEND_ITEMS.map(({ label, dotClassName }) => (
      <span key={label} className="flex items-center gap-1.5">
        <span className={`h-1.5 w-1.5 rounded-full ${dotClassName}`} />
        {label}
      </span>
    ))}
    <div className="flex-1" />
    <span className="font-sp-mono">
      buffer {bufferCount}/{bufferMax}
    </span>
  </div>
);
